import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main
        id="main"
        className="
    relative
    flex
    flex-col gap-12 md:gap-20
    
      lg:col-span-12
    
    max-w-[100%] overflow-hidden md:overflow-visible
  "
      >
        <div
          id="shopify-section-template--21703854555170__page-main"
          className="shopify-section"
        >
          <div
            className="
    flex
    flex-col gap-6
    md:mt-20
    
  "
          >
            <div className="">
              <div className="flex items-center border-b border-solid border-gray-600 pb-6">
                <h1 className="text-sm uppercase leading-5 tracking-wide text-gray-600">
                  Terms &amp; Conditions
                </h1>
              </div>
            </div>
            <div
              className="text-gray-600 tracking-tight leading-5 text-md

[&_*:not(.form-button)]:text-gray-600 [&_*]:mb-0 [&_p]:text-md

[&_h2.anchor-target[id]]:before:content-[' '] [&_h2.anchor-target[id]]:before:-mt-24
[&_h2.anchor-target[id]]:before:block [&_h2.anchor-target[id]]:before:h-24

[&_a:not(.form-button)]:text-gray-500 [&_a:hover]:text-gray-600 [&_a]:transition-colors [&_a]:duration-200 [&_a]:ease-in
[&_p_a]:text-gray-500 [&_p_a:hover]:text-gray-600 [&_p_a]:transition-colors [&_p_a]:duration-200 [&_p_a]:ease-in
[&_p_a_span]:underline [&_p_a_span]:underline-offset-4

[&_h2]:tracking-wide [&_h3]:tracking-wide [&_h4]:tracking-wide [&_h5]:tracking-wide [&_h6]:tracking-tight
[&_p]:tracking-tight [&_li]:tracking-tight

[&_h2]:uppercase [&_h3]:uppercase [&_h4]:uppercase [&_h5]:uppercase

[&_h2]:text-sm [&_h3]:text-sm [&_h4]:text-sm [&_h5]:text-sm [&_h6]:text-sm [&_p]:text-md [&_ul]:text-md

[&_h2]:leading-6 [&_h3]:leading-6 [&_h4]:leading-6 [&_h5]:leading-6 [&_h6]:leading-5 [&_p]:leading-5 [&_ul]:leading-5

[&_p_+_*]:mt-8 [&_ul_+_p]:mt-8 [&_ul_+_h2]:mt-8 [&_ul_+_h3]:mt-8 [&_ul_+_h4]:mt-8 [&_p_+_p]:mt-3.5 [&_p_+_ul]:mt-3.5
[&_h2_+_p]:mt-3.5 [&_h3_+_p]:mt-3.5 [&_h4_+_p]:mt-3.5 [&_h5_+_p]:mt-3.5

[&_p_+_ul_li]:relative [&_p_+_ul_li]:mb-3.5 [&_p_+_ul_li]:before:absolute [&_p_+_ul_li]:before:content-['–']
[&_p_+_ul_li]:before:left-0 [&_li]:pl-3

[&_h6_em]:not-italic [&_h6]:flex [&_h6]:w-full [&_h6]:items-start

[&_table]:w-full [&_table]:max-w-2xl [&_table]:mt-2 [&_td]:p-0 [&_td]:pb-1

[&_ul:first-child]:list-['—'] [&_ul:first-child]:pl-4
"
            >
              <h2>OWNERSHIP</h2>
              <p>
                This website (the "Website") is the website of Margotal Limited
                (registered company no. 02134765) ("we", "us"), whose registered
                office is Flat 18 The Abode, Sunderland Street, Halifax, West Yorkshire, HX1 5AF, email address{" "}
                <Link onClick={toTop} to="mailto:upper@margotal.art">
                  upper@margotal.art
                </Link>
                . Our trading address is Flat 18 The Abode, Sunderland Street, Halifax, West Yorkshire, HX1 5AF and our
                VAT number is 802217671.
              </p>
              <h2>LEGAL AGREEMENT</h2>
              <p>
                This page (together with the documents referred to on it) tells
                you:
              </p>
              <ul>
                <li>1. the terms on which you may use the Website; and</li>
                <li>
                  2. the terms on which we supply to you any of the products
                  ("Products") listed on the Website.
                </li>
              </ul>
              <p>
                By entering the Website, and/or any page accessible on this
                site, and/or by purchasing Products from Margotal Limited
                through the Website, or dealing with Margotal Limited in any way
                through the Website, you accept and agree to be bound by the
                terms and conditions set out below (the "Terms").
              </p>
              <p>
                If you do not wish to be bound by the Terms you should not
                access or use the Website. If you have difficulty in
                understanding these Terms or have any queries regarding these
                Terms, please contact{" "}
                <Link onClick={toTop} to="mailto:upper@margotal.art">
                  upper@margotal.art
                </Link>
                .
              </p>
              <p>
                We may modify the Terms in our absolute discretion from time to
                time. If we intend to make any significant changes to the
                Products or these Terms we will notify you and you may then
                contact us to end the contract and receive a full refund before
                the changes take effect. You will be deemed to have accepted any
                modifications if you continue to use the Website after the
                changes have taken effect.
              </p>
              <h2>TERMS AND CONDITIONS RELATING TO SALES OF PRODUCTS</h2>
              <p>Information that we are required to give you</p>
              <ul>
                <li>
                  A description of the main characteristics of the Products is
                  contained on the Website and will also be contained in our
                  Order Confirmation, described below.
                </li>
                <li>
                  The price of Products (including delivery and packaging
                  charges) and arrangements for payment are as described in
                  these Terms.
                </li>
                <li>
                  The arrangements for delivery of Products are as shown below.
                </li>
                <li>
                  You have a right of cancellation as set out in these Terms.
                </li>
                <li>The language of the contract will be English.</li>
              </ul>
              <h2>CONTRACT</h2>
              <p>
                Your order shall constitute an offer to us to purchase the
                Products specified in the order. At the same time you shall
                complete an authorisation for us to recover, through your credit
                or debit card, payments due to us. We may accept or decline the
                order. Please note that acknowledgement of an order by us does
                not constitute acceptance of that order or that a contract has
                been made. We will confirm acceptance to you by email confirming
                that the order is accepted and that the Product is ready for
                dispatch or has been dispatched ("Order Confirmation") at which
                point a contract will come into existence between you and us. We
                shall at the same time notify you of the identifying number (in
                these Terms the "Identifying Number") for your order and it
                would be helpful if you can quote your Identifying Number in any
                subsequent communications.
              </p>
              <p>
                We reserve the right at our discretion to decline to accept any
                order and/or to supply Products. This might be because the
                Product is out of stock, because we have identified an error in
                the price or description of the Product or because we are unable
                to meet a delivery deadline. If we are unable to accept your
                order, we will inform you of this and will not charge you for
                the Product, or, if you have already paid for the Product(s), we
                shall refund the payment.
              </p>
              <p>
                If you have any difficulty completing an order please telephone{" "}
                <Link onClick={toTop} to="tel:+442075912250">
                  +44 (0)20 7591 2250.
                </Link>
              </p>
              <h2>ENTIRE AGREEMENT</h2>
              <p>
                Each confirmed order shall constitute a separate contract
                between us and shall be governed by these Terms. These Terms
                constitute the entire understanding between us in relation to
                any Products ordered and supplied through the Website. They
                supersede any other terms stipulated by you, whether in any
                order or during negotiations or any course of dealing
                established between you and us.
              </p>
              <p>
                All descriptions, images or illustrations of Products provided
                on this Website or otherwise communicated to you are for
                guidance only and intended merely to present a general idea of
                the Products. Although we have made every effort to display the
                colours accurately, we cannot guarantee that a device's display
                of the colours accurately reflects the colour of the Products.
                Your Product may vary slightly from those images.
              </p>
              <h2>PRICE</h2>
              <p>
                The prices of the Products shall be as quoted on the Website
                from time to time, except in the case of obvious error. All
                prices on the Website are inclusive of United Kingdom VAT and
                packing and exclusive of postage/delivery. For items shipped
                outside of the UK VAT will be deducted from the price on
                confirmation of the shipping country. A summary of delivery
                charges and other relevant information can be found at our
                delivery and shipping information page.
              </p>
              <p>
                The prices of the Products are given in the local currency
                dependent on your shipping destination. Payment for the ordered
                Products are made the currency the order is shipping to.
              </p>
              <p>
                It is always possible that, despite our best efforts, some of
                the Products we sell may be incorrectly priced. We will normally
                check prices before accepting your order so that, where the
                Product's correct price at your order date is less than our
                stated price at your order date, we will charge the lower
                amount. If the Product's correct price at your order date is
                higher than the price stated, we will contact you for your
                instructions before we accept your order.
              </p>
              <p>
                If we accept and process your order where a pricing error is
                obvious and unmistakable and could reasonably been recognised by
                you as mis-pricing, we may end the contract, refund you any sums
                you have paid and require the return of any Products provided to
                you.
              </p>
              <p>
                Please note that only the following methods of payment are
                accepted:
              </p>
              <ul>
                <li>Visa (including Delta and Electron);</li>
                <li>
                  Mastercard (including Maestro and JCB);
                  <br />
                </li>
                <li>American Express</li>
                <li>PayPal</li>
                <li>
                  Apple Pay &amp; Google Pay
                  <br />
                </li>
                <li>Shop Pay</li>
                <li>Alipay</li>
                <li>WeChat Pay</li>
              </ul>
              <p>
                You must pay for the Products before we dispatch them. We will
                charge your credit or debit card at the time of Order
                Confirmation.
              </p>
              <h2>DELIVERY</h2>
              <p>
                We shall deliver Products ordered by you through a courier or
                postal service of our choice to the delivery address that you
                have given us.
              </p>
              <p>
                We deliver within the UK, EU and internationally. Please note we
                do not deliver to Japan, PO Box or BFPO addresses. For Japanese
                orders please visit our{" "}
                <Link onClick={toTop} to="/">
                  Japan website
                </Link>
                . We are currently unable to ship to Ukraine, Russia and
                Belarus.
              </p>
              <p>
                All orders to the EU are shipped inclusive of duties and tax. No
                further costs will be charged on receipt of the order.
                <br />
                <br />
                All orders to the United States are shipped inclusive of duties
                and tax. State taxes will be shown at time of purchase at the
                checkout and no further costs will be charged on receipt of the
                order.
                <br />
                <br />
                Orders delivered outside of the EU and United States are shipped
                inclusive of duties and tax. Local duties and taxes are payable
                at the checkout and are the responsibility of the recipient.
              </p>
              <p>
                Please note that customs, duty and import fees (including
                tariffs and tax) ("Fees") may apply if your Products are shipped
                to a destination outside of the United Kingdom and Europe. These
                Fees are not included in our delivery charges. Our Products are
                delivered duty unpaid. This means that we are responsible for
                transportation costs in the delivery of the Products (in
                accordance with the delivery charges set out below), but not for
                paying any Fees relating to your Product which are imposed at
                the destination. You are responsible for paying all such Fees
                directly to the relevant authorities.
              </p>
              <p>
                When a parcel is delivered you will be asked to sign for it as
                proof of receipt. If you are not there, a card will be dropped
                through your door stating how to get your parcel.
              </p>
              <p>
                Risk of loss or damage to the Products shall pass to you at the
                time of delivery.
              </p>
              <p>
                For information regarding delivery methods, charges, and times,
                please refer to{" "}
                <Link onClick={toTop} to="/">
                  Shipping and Delivery
                </Link>{" "}
                on the Customer Service page.
              </p>
              <p>
                If you have requested a specific delivery date (where such
                option is available to you) we will notify you if it is not
                possible to deliver on the relevant day and give you a new
                delivery time.
              </p>
              <p>Please note that delivery times are only estimates.</p>
              <h2>DELIVER TO SHOP</h2>
              <p>Currently, we do not offer a Deliver To Shop service.</p>
              <h2>CHILDREN</h2>
              <p>
                We do not sell products for purchase by children. If you are
                under 18, you may use this Website only with the involvement of
                a parent or guardian.
              </p>
              <h2>RIGHT TO CANCEL</h2>
              <p>
                You are entitled to cancel an order for a Product, and end your
                contract with us, for any reason within 28 days of receipt of
                the Product. If you exercise this right, you will receive a full
                refund of the price paid for the Product in accordance with our
                Refunds Policy (below).
              </p>
              <p>
                To end the contract with us, please let us know by doing one of
                the following:
              </p>
              <p>
                (a) Phone or email. Call our customer service team on{" "}
                <Link onClick={toTop} to="tel:+442075912250">
                  +44 (0)20 7591 2250
                </Link>{" "}
                or email us at{" "}
                <Link onClick={toTop} to="mailto:upper@margotal.art">
                  upper@margotal.art
                </Link>
                . Please provide your name, details of the order, Identifying
                Number if available and your contact details (phone number,
                email address and home address).(b) By post. Print off the
                Cancellation Form and post it to us at the address on the form.
                Or simply write to us as that address, including the information
                required in the form.
              </p>
              <p>
                Your right of cancellation described in this section is in
                addition to any other right that you might have to reject the
                Products, for instance because they are faulty (see below).
              </p>
              <h2>FAULTY PRODUCTS</h2>
              <p>
                If you have any questions or complaints about the Product, or if
                your Product is faulty, please contact us by calling our
                customer service team at{" "}
                <Link onClick={toTop} to="tel:+442075912255">
                  +44 (0)20 7591 2255
                </Link>{" "}
                or emailing us at{" "}
                <Link onClick={toTop} to="mailto:upper@margotal.art">
                  upper@margotal.art
                </Link>
                .
              </p>
              <p>
                If what you have bought is faulty you may have a legal right to
                end the contract (or to get the Product repaired or replaced or
                to get some or all of your money back).
              </p>
              <p>
                If when you receive your Product you discover a fault or it is
                not as described, you have 30 days from receipt of the Product
                to return the Product to us and receive a refund.
              </p>
              <p>
                If a fault occurs in the Product after 30 days of receipt of the
                Product, we will offer you an exchange (for the equivalent
                amount) or if we can we will repair the Product.
              </p>
              <p>
                If your faulty Product cannot be repaired or replaced, then we
                will offer you a refund.
              </p>
              <p>
                If you wish to exercise your legal rights to reject faulty
                Products you must return them to us in accordance with the
                Returns section below.
              </p>
              <h2>RETURNS</h2>
              <p>
                When returning any Product to us, you must take reasonable care
                to ensure that they are received by us and not damaged in
                transit. We recommend that you send returns by recorded post and
                always retain proof of postage.
              </p>
              <p>
                If you exercise your right to cancel the contract because you
                have changed your mind:
              </p>
              <p>
                (a) You must return the Products in one of the ways set out
                below within 28 days of telling us you wish to end the contract
                (b) Please include a completed{" "}
                <Link onClick={toTop} to="/">
                  Returns Form
                </Link>{" "}
                when you return your Products so that we can identify your order
                and process your returns.(c) You are responsible for the cost of
                returning the Product to us.
              </p>
              <p>
                Please note that our returns policy is reduced to 14 days for
                all sale purchases.
              </p>
              <p>If you are returning a faulty Product to us:</p>
              <p>
                (a) You must return the Products in one of the ways set out
                below within 28 days of telling us you wish to end the
                contract.(b) Please include a completed{" "}
                <Link onClick={toTop} to="/">
                  Returns Form
                </Link>{" "}
                when you return your Products so that we can identify your order
                and process your returns.(c) We will bear any reasonable cost of
                posting the Product to us.
              </p>
              <p>
                <strong>
                  Please note we do not accept returns of underwear or earrings
                </strong>
              </p>
              <p>Returns should be sent to us by:</p>
              <p>
                UK - Posting the Product back to us along with a completed&nbsp;
                <Link onClick={toTop} to="/">
                  Returns Form
                </Link>{" "}
                to: Margotal Returns Department, Flat 18 The Abode, Sunderland Street, Halifax, West Yorkshire, HX1 5AF and providing
                your original Order Number;&nbsp;
                <br />
                <br />
                REST OF WORLD - Completing the{" "}
                <Link onClick={toTop} to="/">
                  Global-E Returns Form
                </Link>
              </p>
              <h2>RETURNS POLICY</h2>
              <p>
                If you exercise your right to cancel your contract with us in
                accordance with these Terms, we will refund you the price you
                paid for the Products, including standard delivery costs, by the
                method you used for payment. However, we may make deductions
                from the price, as described below.
              </p>
              <p>If you are exercising your right to change your mind:</p>
              <p>
                (a) We may reduce your refund of the price (excluding delivery
                costs) to reflect any reduction in the value of the Products, if
                this has been caused by your handling them in a way which would
                not be permitted in a shop. You are entitled to inspect the
                Products after delivery. However, you must take reasonable care
                of the Products and not let them out of your possession. If we
                refund you the price paid before we are able to inspect the
                Products and later discover you have handled them in an
                unacceptable way, you must pay us an appropriate amount.(b) The
                maximum refund for delivery costs will be the costs of delivery
                by the least expensive delivery method we offer. For example, if
                we offer delivery of a product within 2 - 3 working days at one
                cost but you choose to have the Product delivered within 24
                hours at a higher cost, then we will only refund what you would
                have paid for the cheaper delivery option.
              </p>
              <p>
                If you are exercising your right to change your mind then your
                refund will be made within 14 days from the day on which we
                receive the Product back from you or, if earlier, the day on
                which you provide us with evidence that you have sent the
                Product back to us.
              </p>
              <p>
                If you are returning a faulty Product for a refund in accordance
                with these Terms, we will refund you the price you paid for the
                Products, including standard delivery costs, by the method you
                used for payment. Your refund will be made within 14 days of us
                agreeing that you are entitled to a refund.
              </p>
              <h2>ONLINE GIFT CARDS</h2>
              <p>
                <strong>Terms of purchasing Gifts Cards</strong>
              </p>
              <ul>
                <li>
                  You will receive an order confirmation email upon placing the
                  order.
                </li>
                <li>
                  Online Gift Cards are delivered to the recipient via email
                  shortly after purchase.
                </li>
                <li>
                  Online Gift Cards must be purchased separately and cannot
                  purchased in combination with other items.
                </li>
                <li>
                  Online Gift Cards are non-refundable and valid for 12 months
                  from the date of purchase and redeemable Online only.
                </li>
                <li>Gift Cards are available in GBP £ only.</li>
              </ul>
              <p>
                <strong>Terms of redeeming Gifts Cards</strong>
              </p>
              <ul>
                <li>
                  Online Gift Cards are redeemable only via the website region
                  and currency they were purchased.
                </li>
                <li>
                  Online Gift Cards are sent as a unique code which can be
                  applied at checkout. The amount can be used in full or
                  partially redeemed. Balances can be viewed at the checkout.
                </li>
                <li>Only one Online Gift Card can be used per order.</li>
                <li>
                  Online Gift Cards are redeemed by entering a unique code at
                  checkout and selecting 'Apply'. The balance can be viewed by
                  entering in your unique code at checkout and selecting
                  'Balance'.
                </li>
                <li>
                  If your order exceeds your Online Gift Card value, any
                  remaining balance can be paid for by debit or credit card or
                  Paypal.
                </li>
                <li>
                  We reserve the right to block Online Gift Cards, if misused.
                </li>
                <li>
                  Online Gift Cards cannot be returned or exchanged for cash.
                </li>
                <li>
                  All returned items that were paid for with an Online Gift Card
                  will be refunded as an Online Gift Card balance, which can be
                  redeemed against future orders with your unique code. If you
                  paid with a combination of payment card and Online Gift Card,
                  anything paid by debit or credit card or PayPal will be
                  refunded first, then the remaining amount will be credited to
                  your Online Gift Card.
                </li>
                <li>
                  Margotal is not responsible if your Online Gift Card is lost,
                  stolen, destroyed, or used without your permission.
                </li>
                <li>
                  For further enquires please contact us by email{" "}
                  <Link onClick={toTop} to="mailto:upper@margotal.art">
                    upper@margotal.art
                  </Link>{" "}
                  or by telephone{" "}
                  <Link onClick={toTop} to="tel:+442075912250">
                    +44 (0)20 7591 2250
                  </Link>{" "}
                  Monday to Friday 10:00 - 18:00 GMT. We aim to respond to any
                  enquiries within 24 working hours of receipt. Monday to
                  Friday, excluding UK National Holidays.
                </li>
              </ul>
              <h2>CUSTOMER SERVICES</h2>
              <p>
                If you have any comments with regard to the service you have
                experienced in placing orders on, or using, this Website, please
                contact us:
              </p>
              <p>
                Email:{" "}
                <Link onClick={toTop} to="mailto:upper@margotal.art">
                  upper@margotal.art
                </Link>
              </p>
              <p>Post: Margotal Limited, Flat 18 The Abode, Sunderland Street, Halifax, West Yorkshire, HX1 5AF</p>
              <p>
                Please note that orders for Products cannot be placed via
                Customer Services.
              </p>
              <h2>LIABILITY</h2>
              <p>
                Margotal Limited will be responsible for any loss or damage you
                suffer as a result of our breaching these conditions if the loss
                or damage was a reasonable foreseeable result of our breaking
                this contract when you commenced using the Website, or if a
                contract for the sale of goods by us to you was formed.
              </p>
              <p>
                We will not be responsible for any economic or business loss
                (including loss of profits, revenue, contracts, anticipated
                savings, data, goodwill or wasted expenditure) or for any
                indirect or consequential loss that was not reasonably
                foreseeable to both you and us when you commenced using the
                Website or when a contract for the sale of goods by us to you
                was formed. Margotal Limited does not limit in any way our
                liability for death or personal injury arising from a negligent
                act or omission on our part.
              </p>
              <h2>YOUR STATUTORY RIGHTS</h2>
              <p>
                Nothing in these Terms shall affect your statutory rights. If
                you have any doubts as to your statutory rights then you should
                contact a solicitor or your local Citizens Advice Bureau.
              </p>
              <h2>TERMS AND CONDITIONS RELATING TO USE OF THE WEBSITE</h2>
              <h2>INFORMATION ON THE WEBSITE</h2>
              <p>
                Unless specifically stated otherwise, we are not responsible for
                the information relating to Margotal Limited on the Website and
                make no warranty in respect of its timeliness, accuracy or
                availability. The information provided is subject to our{" "}
                <Link onClick={toTop} to="/privacy">
                  Privacy Policy
                </Link>{" "}
                which you should read before accessing such information.
              </p>
              <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
              <p>
                The Website, and all the text, information and graphic
                representations or images on it ("Content"), are owned by, or
                licensed to us. The copyright and all other intellectual
                property rights in the Content are our sole and exclusive
                property of or that of our licensors.
              </p>
              <p>
                You may view the Website on your computer screen and print its
                contents on your printer for your personal and non-commercial
                use only. For the avoidance of doubt, anything printed will form
                part of the Content.
              </p>
              <p>
                Without our prior written consent, you may not use, transfer,
                copy or reproduce any part of the Content, this Website or its
                source HTML code in whole or in part, in any form or by any
                means, electronic, mechanical or otherwise, except for the sole
                purpose of viewing its content. This includes electronic
                reproduction by uploading or downloading.
              </p>
              <p>
                You warrant that it is legal for you to view this Website in the
                jurisdiction to which you are subject. You are responsible for
                compliance with all laws of that jurisdiction, in viewing or
                using the Content.
              </p>
              <h2>USING THE WEBSITE</h2>
              <p>
                Wherever you are asked to provide information in connection with
                the Website, you agree to provide true, accurate, current and
                complete details. You are not obliged to provide us with any
                optional information requested.
              </p>
              <p>
                <strong>You agree not to:</strong>
              </p>
              <ul>
                <li>
                  impersonate another person or use a false name or a name you
                  are unauthorised to use, or create a false identity or origin
                  or e-mail address or try to mislead us or others as to
                  identity or origin of any communications or to provide
                  inaccurate or unreliable contact details;
                </li>
                <li>
                  modify, access or make available data stored on a computer or
                  device which you have accessed through our network, when
                  either: the owner of the data, computer or device has taken
                  steps to prevent you from doing this; or the owner has
                  expressed a wish that you do not do this;
                </li>
                <li>
                  make available or upload files that contain software or other
                  material, data or information not owned by or licensed to you
                  or collect information about others (e.g. names/addresses)
                  without their prior consent;
                </li>
                <li>
                  damage, interfere with or disrupt access to the Website or do
                  anything which might impair its functionality;
                </li>
                <li>
                  use the Website in any way to send unsolicited (commercial or
                  otherwise) e-mail or any material for marketing or publicity
                  purposes, or any similar abuse; publish, post, distribute,
                  disseminate or otherwise transmit defamatory offensive,
                  infringing, obscene, indecent or other unlawful or
                  objectionable material or information;
                </li>
                <li>
                  make available, upload or distribute by any means any material
                  or files that contain any viruses, bugs, corrupt data, "trojan
                  horses", "worms" or any other harmful software;
                </li>
                <li>
                  falsify the true ownership of software or other material or
                  information contained in a file made available via the
                  Website;
                </li>
                <li>
                  obtain or attempt to obtain unauthorised access, through
                  whatever means, to the Website.
                </li>
              </ul>
              <h2>NO UNLAWFUL OR PROHIBITED USE</h2>
              <p>
                You undertake not to use the Website for any purpose or in any
                way that is prohibited by these Terms or is otherwise unlawful.
              </p>
              <p>
                You agree to indemnify us, our officers, employees, and
                licensors in respect of any loss that we or they may suffer as a
                result, directly or indirectly, of any breach by you of this
                undertaking.
              </p>
              <h2>OUR USE OF YOUR PERSONAL DETAILS</h2>
              <p>
                Please see our{" "}
                <Link onClick={toTop} to="/">
                  Privacy Policy
                </Link>
                <Link onClick={toTop} to="/privacy">
                  .
                </Link>
              </p>
              <h2>
                LIABILITY DISCLAIMER REGARDING ACCESS TO OR USE OF THE WEBSITE
              </h2>
              <p>
                These provisions do not deal with liability arising from
                purchases of Products (for which see the provisions headed
                "Liability" under the 'Terms and Conditions relating to sales of
                Products' above).
              </p>
              <p>
                You agree that you use the Website entirely at your own risk.
              </p>
              <p>
                In preparing this Website, we have endeavoured to offer current,
                correct and clearly expressed information. However, we cannot
                guarantee that the information will be accurate, complete or
                current at all times and accepts no liability for any reliance
                placed by any person on the information.
              </p>
              <p>
                We make no representations or warranties of any kind about the
                suitability, reliability, timeliness, and accuracy of the
                information contained on this Website for any purpose. We
                expressly disclaim all warranties and conditions with regard to
                this information, including, without limitation, warranties of
                technical efficiency, satisfactory quality, availability,
                non-infringement, completeness and fitness for a particular
                purpose to the extent permitted by law.
              </p>
              <p>
                We do not accept any responsibility for any errors or
                inaccuracies in any advertising material, and are not
                responsible for and does not endorse the content of any such
                advertisements.
              </p>
              <p>
                We shall not be liable for any damages whatever, including but
                without limitation to, damages for loss of data or profits,
                arising out of the use or performance of this Website, the
                provision of or failure to provide services, or for any
                information obtained through this Website, or otherwise arising
                out of the use of this Website, whether based on contract, tort,
                or otherwise, without limitation, even if we have been advised
                of the possibility of such damage.
              </p>
              <p>
                If you are dissatisfied with any portion of this Website, or
                with any of these terms of use, your sole remedy, except as
                specifically provided in these terms, is to stop using the
                Website.
              </p>
              <p>
                Notwithstanding anything in these Terms, we do not disclaim
                liability for death or injury caused by our own negligence.
              </p>
              <p>
                We reserve the right to remove any information or material on
                the Website without warning, and without prejudice to any other
                accrued rights, and/or make available such information or
                material when required to do so by law or when requested to do
                so by regulatory bodies or law enforcement organisations.
              </p>
              <h2>AVAILABILITY</h2>
              <p>
                We reserve the right at any time to modify or discontinue,
                temporarily or permanently, your access to or use of the Website
                with or without notice.
              </p>
              <h2>VIRUS PROTECTION AND COMPATIBILITY</h2>
              <p>
                While certain precautions have been taken to detect computer
                viruses and ensure security, we cannot guarantee that the
                Website is virus-free and secure.
              </p>
              <p>
                We shall not be liable for any loss or damage which occurs as a
                result of any virus or breach of security. We do not give any
                warranties as to the compatibility of the Website with your
                computer systems, software and/or hardware.
              </p>
              <h2>LINKS TO THIRD PARTY SITES</h2>
              <p>
                This Website contains links to websites operated by other people
                and organisations ("Third Party Websites"). When you activate
                one of them, you will leave the Website. We have no control
                over, and will accept no responsibility for or liability in
                respect of, material on any website that is not under our
                control.
              </p>
              <p>
                The inclusion of links to Third Party Websites does not imply
                any endorsement of the material on them or any association with
                their operators.
              </p>
              <p>
                You will not arrange for any Third Party Website to be connected
                to any part of the Website by way of hyperlink or otherwise
                without our written consent.
              </p>
              <h2>TERMINATION OF USE</h2>
              <p>
                We may restrict your access to the Website, refuse to correspond
                with you, and/or remove your details from the relevant database
                without prejudice to any other accrued rights, without prior
                notice to you where:
              </p>
              <ul>
                <li>
                  there is a regulatory or statutory change limiting the ability
                  to provide access to the Website;
                </li>
                <li>
                  there is any event beyond our reasonable control preventing us
                  from providing access to the Website (for example, and without
                  limitation, technical difficulties, capacity problems and
                  communications failures);
                </li>
                <li>
                  we consider in our sole discretion that you are abusing the
                  Website or are otherwise acting in breach of these Terms.
                </li>
              </ul>
              <h2>MONITORING</h2>
              <p>
                We reserve the right to monitor and track your visits to the
                Website in accordance with our Privacy Policy.
              </p>
              <h2>GENERAL</h2>
              <p>
                A failure or delay by us in enforcing compliance with these
                Terms shall not be a waiver of that or any other provision of
                these Terms.
              </p>
              <p>
                None of these Terms shall be enforceable under the Contracts
                (Rights of Third Parties) Act 1999 by any third party.
              </p>
              <p>
                Any rights not expressly granted in these Terms are reserved to
                us.
              </p>
              <p>
                If we are hindered or prevented from performing our obligations
                under these Terms for (i) any cause beyond our reasonable
                control (including but not limited to acts or omissions of
                providers of telecommunications services or faults in or
                failures of their networks or equipment); or (ii) by reason of
                our inability to procure services, materials or articles
                required for the performance of the contract except at prices
                higher than those applicable at the date of your order, then we
                may at our sole option delay the performance of, or cancel the
                whole or any part of the contract. In that event, we shall not
                be responsible for our delay or cancellation or any inability to
                deliver or perform our obligations.
              </p>
              <p>
                If any provisions of these disclaimers and exclusions shall be
                unlawful, void or for any reason unenforceable then that
                provision shall be deemed severable and shall not affect the
                validity and enforceability of the remaining provisions.
              </p>
              <p>
                These Terms constitute the entire agreement between us as to
                your use of the Website and shall supersede any prior agreement
                or representation made between us.
              </p>
              <p>
                The express provisions of these Terms are in place of all
                warranties, conditions, terms, undertakings and obligations
                implied by statute, common law, custom, trade usage, course of
                dealing or otherwise, all of which are excluded to the fullest
                extent permitted by law.
              </p>
              <p>
                Any and all notices to be given by either one of us to the other
                pursuant to or in connection with these Terms shall be deemed
                sufficiently given when forwarded by e-mail or facsimile
                transmission in each case addressed to you at the e-mail address
                or facsimile number you have given us or to us at the e-mail
                address or facsimile number displayed on the Website.
              </p>
              <p>
                English law governs these Terms. You submit to the non-exclusive
                jurisdiction of the English courts.
              </p>
              <h2>COPYRIGHT AND TRADE MARK NOTICES</h2>
              <p>
                All contents of this Website are: Copyright 2023 Margotal
                Limited
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Terms;
